<template>
  <RegistrationForm></RegistrationForm>
</template>

<script>
import RegistrationForm from "../../components/Auths/Registration.vue";
export default {
  name: "Registration Form View",
  components: { RegistrationForm },
  computed: {},
};
</script>
